import { render } from "./ChoixPatient.vue?vue&type=template&id=826696dc&scoped=true"
import script from "./ChoixPatient.vue?vue&type=script&lang=js"
export * from "./ChoixPatient.vue?vue&type=script&lang=js"

import "./ChoixPatient.vue?vue&type=style&index=0&id=826696dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826696dc"]])

export default __exports__